/** Helper function that generates an array of [0..n-1] elements. */
export function range(n) {
  return [...Array(n).keys()]
}



// WEBPACK FOOTER //
// ./src/domain/helpers/Range.js